import {useEffect, useMemo, useState} from "react";
import {useRecoilState, } from "recoil";
import lodashClonedeep from "lodash.clonedeep";
import {useClickAway} from "@uidotdev/usehooks";
import {subProductsCopyParametersState, } from "@/store";
import {
  userMultiParameterModalValues
} from "@/widgets/shared-admin-customers/digital-offset-price/multi-parameter-modal/use-multi-parameter-modal-values";
import {
  findColorDetailSettingParam,
  getLockedColorIdsFromValueConfig,
  getMaxColorSelectionFromValueConfig,
} from "./printing-colors-preset-utils";

const useSubChildMapping = ({
  forceChange,
  parameters,
  settingParameters,
  value,
  index,
  parentValue,
  item,
  isParameterSettings,
  setSettingParameters
}) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [subProducts, setSubProducts] = useRecoilState<any>(subProductsCopyParametersState);
  const {
    addValueToSubProduct,
    removeValueFromSubProduct,
    setSubProductValue,
    setSubProductValueForParameterSettings,
    setSubProductValueForParameterSettingsDefaultValueArray,
  } = userMultiParameterModalValues(settingParameters,isParameterSettings)
  const ref = useClickAway(() => {
    setIsFocused(false);
  });
  const getSelectedColorParameterValue = () => {
    if (subProducts && !isParameterSettings) {
      const subSection = settingParameters.subSection;
      const subProductType = subSection.type;
      let subProduct = subProducts?.find(sub => sub.type === subProductType);
      const colorParameter = findColorDetailSettingParam(
        settingParameters?.parameter?.settingParameters ?? [],
        settingParameters?.parameter?.code
      );
      if (!colorParameter) return null;
      const matches =
        subProduct?.parameters?.filter(
          (paramValue) => paramValue.parameterId === colorParameter.id
        ) ?? [];
      if (!matches.length) return null;
      return matches.reduce((best, current) => {
        const bestLen = best?.valueIds?.length ?? 0;
        const currentLen = current?.valueIds?.length ?? 0;
        return currentLen > bestLen ? current : best;
      });
    } else {
      const valuesConfigs = settingParameters?.parameter?.valuesConfigs;
      const valueConfigDefault = valuesConfigs?.find((item) => item.isDefault);
      if(valueConfigDefault){
        const colorParameter = settingParameters?.parameter?.settingParameters.find(item => item.code === "printingcolorsDetail" || item.code === "printingcolorsDetailSide2");
        return valueConfigDefault?.selectedParameterValues?.find(paramValue => paramValue.parameterId === colorParameter.id);
      }
    
    }
  };
  const [isChecked, setIsChecked] = useState(false);

// useEffect(()=>{
//   getSelectedColorParameterValue()
// },[])

  const getActiveValueConfig = () => {
    const settingParamsList =
      settingParameters?.parameter?.settingParameters ?? [];
    if (isParameterSettings) {
      const defaultValueConfig =
        settingParameters?.parameter?.valuesConfigs?.find(
          (item: any) => item.isDefault
        );
      return defaultValueConfig ?? null;
    }
    if (!subProducts) return null;
    const subSection = settingParameters?.subSection;
    const subProduct = subProducts.find(
      (sub: any) => sub.type === subSection?.type
    );
    const parameterValue = subProduct?.parameters?.find(
      (paramValue: any) =>
        paramValue.parameterId === settingParameters?.parameter?.id
    );
    const configId = parameterValue?.valueIds?.[0];
    if (!configId) return null;
    return settingParameters?.parameter?.valuesConfigs?.find(
      (conf: any) => conf.id === configId
    );
  };

  const lockedColorIds = useMemo(() => {
    const valueConfig = getActiveValueConfig();
    if (!valueConfig) return null;
    return getLockedColorIdsFromValueConfig(
      valueConfig,
      settingParameters?.parameter?.settingParameters ?? []
    );
  }, [subProducts, settingParameters, isParameterSettings]);

  const isColorSelectionLocked = !!lockedColorIds?.length;

  const onChangeCheckBox = (e) => {
    if (isColorSelectionLocked) {
      return;
    }
    if (isParameterSettings) {
      const printingcolorsDetail = parameters.find(item => item.code === "printingcolorsDetail" || item.code === "printingcolorsDetailSide2");
      const loadParameter = parameters.find(p => p.code === "Colorloadpercentage" || p.code === "ColorloadpercentageSide2");
      const layersParameter = parameters.find(p => p.code === "ColorLayers" || p.code === "ColorLayersSide2");
      const parameter = settingParameters?.parameter;
      const valuesConfigsList = parameter?.valuesConfigs;
      const defaultValueConfig = valuesConfigsList?.find(item => item.isDefault);
  
      if (defaultValueConfig) {
        let selectedParameterValues = defaultValueConfig.selectedParameterValues.map(paramValue => {
          if (paramValue.parameterId === printingcolorsDetail.id) {
            const maxSelection = getMaxColorSelectionFromValueConfig(
              defaultValueConfig,
              parameters
            );
            if (e.target.checked) {
              const limit =
                maxSelection ??
                paramValue.selectValuesCount ??
                Number.MAX_SAFE_INTEGER;
              if (paramValue.valueIds.length < limit) {
                paramValue.valueIds.push(value.valueId);
              }
            } else {
              const removeIndex = paramValue.valueIds.findIndex(
                (val) => val === value.valueId
              );
              if (removeIndex !== -1) {
                paramValue.valueIds = paramValue.valueIds.filter(
                  (_, index) => index !== removeIndex
                );
              }
            }
          }
          return paramValue;
        });
  
        const ensureParameterValue = (paramId) => {
          let paramValue = selectedParameterValues.find(pv => pv.parameterId === paramId);
          if (!paramValue) {
            paramValue = { parameterId: paramId, valueIds: [], selectValuesCount: selectedParameterValues[0]?.selectValuesCount };
            selectedParameterValues.push(paramValue);
          }
          return paramValue;
        };
  
        const loadParamValue = ensureParameterValue(loadParameter.id);
        const layersParamValue = ensureParameterValue(layersParameter.id);
  
        const colorParamValue = selectedParameterValues.find(pv => pv.parameterId === printingcolorsDetail.id);
        const colorDefaultValueArray = printingcolorsDetail.defaultValueArray;
  
        // Sync load and layer values with the selected color values
        const updateValues = (paramValue, defaultValueArray) => {
          const newValues = colorParamValue.valueIds.map(val => {
            const index = colorDefaultValueArray.findIndex(defaultVal => defaultVal === val);
            return defaultValueArray[index];
          });
          paramValue.valueIds = newValues;
        };
  
        updateValues(loadParamValue, loadParameter.defaultValueArray);
        updateValues(layersParamValue, layersParameter.defaultValueArray);
  
        const updatedParameter = {
          ...parameter,
          valuesConfigs: valuesConfigsList.map(config => {
            if (config.isDefault) {
              return {
                ...config,
                selectedParameterValues
              };
            }
            return config;
          })
        };
        setSettingParameters(prev => ({
          ...prev,
          parameter: updatedParameter
        }));
      }
    }  else {
      let newSubProducts = lodashClonedeep(subProducts);
      if (e.target.checked) {
        newSubProducts = addValueToSubProduct(newSubProducts, value,settingParameters,settingParameters?.section,settingParameters?.subSection);
        setSubProducts(newSubProducts);
        setIsChecked(true);
      } else {
        newSubProducts = removeValueFromSubProduct(newSubProducts, value);
        setSubProducts(newSubProducts);
        setIsChecked(false);
      }
    }
  };
  const isCheckedMemo = useMemo(() => {
    const colorParameterValue = getSelectedColorParameterValue();
    if (isParameterSettings) {
      return colorParameterValue?.valueIds?.includes(value.valueId);
    } else {
      return colorParameterValue?.valueIds?.includes(value.valueId);
    }
  }, [subProducts, settingParameters, isParameterSettings, value,getSelectedColorParameterValue]);

  useEffect(() => {
    setIsChecked(isCheckedMemo);
  }, [isCheckedMemo]);


  const textInputValue = useMemo(() => {
    if (!isParameterSettings) {
      const settingParamsList =
        settingParameters?.parameter?.settingParameters ?? [];
      const isLoadParam =
        item?.code === "Colorloadpercentage" ||
        item?.code === "ColorloadpercentageSide2";
      const isLayersParam =
        item?.code === "ColorLayers" || item?.code === "ColorLayersSide2";

      if (subProducts) {
        const subSection = settingParameters.subSection;
        const subProduct = subProducts.find(
          (sub) => sub.type == subSection?.type
        );
        const colorParameter = findColorDetailSettingParam(
          settingParamsList,
          settingParameters?.parameter?.code
        );
        if (colorParameter) {
          const colorMatches =
            subProduct?.parameters?.filter(
              (paramValue) => paramValue.parameterId === colorParameter.id
            ) ?? [];
          const colorParameterValue = colorMatches.length
            ? colorMatches.reduce((best, current) => {
                const bestLen = best?.valueIds?.length ?? 0;
                const currentLen = current?.valueIds?.length ?? 0;
                return currentLen > bestLen ? current : best;
              })
            : null;

          if (colorParameterValue) {
            const valueIndex = colorParameterValue.valueIds.findIndex(
              (val) => val === value.valueId
            );
            if (valueIndex !== -1) {
              const parameterMatches =
                subProduct?.parameters?.filter(
                  (paramValue) => paramValue.parameterId === item.id
                ) ?? [];
              const parameterValue = parameterMatches.length
                ? parameterMatches.reduce((best, current) => {
                    const bestLen = Math.max(
                      best?.values?.length ?? 0,
                      best?.valueIds?.length ?? 0
                    );
                    const currentLen = Math.max(
                      current?.values?.length ?? 0,
                      current?.valueIds?.length ?? 0
                    );
                    return currentLen > bestLen ? current : best;
                  })
                : null;
              const saved =
                parameterValue?.values?.[valueIndex] ??
                parameterValue?.valueIds?.[valueIndex];
              if (saved != null && saved !== "") {
                return saved;
              }
            }
          }
        }
      }

      if (isLoadParam || isLayersParam) {
        const catalogParam = settingParamsList.find((p) => p.id === item.id);
        const colorParameter = settingParamsList.find(
          (p) =>
            p.code === "printingcolorsDetail" ||
            p.code === "printingcolorsDetailSide2"
        );
        const colorIds =
          colorParameter?.defaultValueArray?.length > 0
            ? colorParameter.defaultValueArray
            : [];
        const valueIndex = colorIds.findIndex((id) => id === value.valueId);

        if (
          valueIndex !== -1 &&
          catalogParam?.defaultValueArray?.length > valueIndex &&
          catalogParam.defaultValueArray[valueIndex] != null
        ) {
          return catalogParam.defaultValueArray[valueIndex];
        }
        if (isLoadParam && catalogParam?.defaultValue != null) {
          return catalogParam.defaultValue;
        }
        if (catalogParam?.defaultValue != null) {
          return catalogParam.defaultValue;
        }
      }

      return item.defaultValue;
    }
    else {
      const colorParameter = settingParameters?.parameter?.settingParameters.find(param => param.code === "printingcolorsDetail" || param.code === "printingcolorsDetailSide2");
      if (!colorParameter) return item.defaultValue;
  
      const valueIndex = colorParameter?.defaultValueArray?.findIndex(val => val === value.valueId);
      const parameterToUpdate = settingParameters?.parameter?.settingParameters.find(param => param.id === item.id);
      if (!parameterToUpdate) return item.defaultValue;

      if (
        valueIndex !== -1 &&
        parameterToUpdate.defaultValueArray &&
        parameterToUpdate.defaultValueArray.length > valueIndex
      ) {
        return parameterToUpdate.defaultValueArray[valueIndex];
      }

      const isLoadParam =
        item?.code === "Colorloadpercentage" ||
        item?.code === "ColorloadpercentageSide2";
      if (isLoadParam && parameterToUpdate.defaultValue != null) {
        return parameterToUpdate.defaultValue;
      }

      return item.defaultValue;
    }
   
  }, [subProducts, isParameterSettings, item, value, settingParameters, parameters]);
  const setTextInputValue = (textInputVal, parameterId) => {
    if (isParameterSettings) {
      const parameter = settingParameters?.parameter;
      const valuesConfigsList = parameter?.valuesConfigs;
      const defaultValueConfig = valuesConfigsList?.find(item => item.isDefault);
      
      const updatedParameters = setSubProductValueForParameterSettings(defaultValueConfig?.selectedParameterValues, parameterId, value, textInputVal);
      const updatedParametersDefaultValueArray = setSubProductValueForParameterSettingsDefaultValueArray(settingParameters?.parameter?.settingParameters, parameterId, value, textInputVal);
      setSettingParameters(prev => ({
        ...prev,
        parameter: {
          ...parameter,
          settingParameters: updatedParametersDefaultValueArray,
          valuesConfigs: valuesConfigsList.map(config => 
            config.isDefault ? { ...config, selectedParameterValues: updatedParameters } : config
          )
        }
      }));
    } else {
      // Existing logic for subProducts update
      let newSubProducts = lodashClonedeep(subProducts);
      newSubProducts = setSubProductValue(newSubProducts, item.id, value, textInputVal);
      setSubProducts(newSubProducts);

      const isLoadOrLayers =
        item?.code === "Colorloadpercentage" ||
        item?.code === "ColorloadpercentageSide2" ||
        item?.code === "ColorLayers" ||
        item?.code === "ColorLayersSide2";
      if (isLoadOrLayers && setSettingParameters) {
        const updatedCatalog =
          setSubProductValueForParameterSettingsDefaultValueArray(
            settingParameters?.parameter?.settingParameters,
            item.id,
            value,
            textInputVal
          );
        setSettingParameters((prev) => ({
          ...prev,
          parameter: {
            ...prev.parameter,
            settingParameters: updatedCatalog,
          },
        }));
      }
    }
  };
  const onChangeText = (e,paramId) => {
    setTextInputValue(e.target.value,paramId);
  };

  const incrementValue = (paramId) => {
    let currentValue = textInputValue.toString();
    currentValue = (parseInt(currentValue) + 1).toString();
    setTextInputValue(currentValue,paramId);
  };
  const decrementValue = (paramId) => {
    let currentValue = textInputValue.toString();
    currentValue = (parseInt(currentValue) - 1).toString();
    setTextInputValue(currentValue,paramId);
  };

  const getMaxSelectionValues = () => {
    const settingParamsList =
      settingParameters?.parameter?.settingParameters ?? [];
    if (!isParameterSettings) {
      if (!subProducts) return null;
      const subSection = settingParameters.subSection;
      const subProductType = subSection.type;
      const subProduct = subProducts.find(
        (sub: any) => sub.type === subProductType
      );
      if (!subProduct) return null;
      const parameterValue = subProduct?.parameters?.find(
        (paramValue: any) =>
          paramValue.parameterId === settingParameters.parameter.id
      );
      const configId = parameterValue?.valueIds?.[0];
      if (!configId) return null;
      const valueConfig = settingParameters.parameter.valuesConfigs.find(
        (conf: any) => conf.id === configId
      );
      return getMaxColorSelectionFromValueConfig(
        valueConfig,
        settingParamsList
      );
    }
    const valuesConfigs = settingParameters.parameter.valuesConfigs;
    const defaultValueConfig = valuesConfigs.find(
      (item: any) => item.isDefault
    );
    return getMaxColorSelectionFromValueConfig(
      defaultValueConfig,
      settingParamsList
    );
  };
  const isDisabled = useMemo(() => {
    if (isColorSelectionLocked) {
      return true;
    }
    if(isParameterSettings){
      const maxSelection = getMaxSelectionValues();
      if (maxSelection === null) return false;
    
      const colorParameterValue = getSelectedColorParameterValue();
      if (colorParameterValue && colorParameterValue.valueIds) {
        const isValueExists = colorParameterValue.valueIds.includes(value.valueId);
        return !isValueExists && colorParameterValue.valueIds.length >= maxSelection;
      }
    
      return false;
    }
    else{
      const maxSelection = getMaxSelectionValues();
      if (maxSelection === null) return false;
    
      const colorParameterValue = getSelectedColorParameterValue();
      if (colorParameterValue?.valueIds) {
        const isValueExists = colorParameterValue.valueIds.includes(value.valueId);
        return !isValueExists && colorParameterValue.valueIds.length >= maxSelection;
      }
    
      return false;
    }
    
  }, [subProducts, settingParameters, isParameterSettings, value, getSelectedColorParameterValue, isColorSelectionLocked]);
  
  return {
    ref,
    isFocused,
    onChangeCheckBox,
    isDisabled,
    incrementValue,
    decrementValue,
    setIsFocused,
    onChangeText,
    isChecked,
    textInputValue,
    isCheckedMemo,
  };
};

export { useSubChildMapping };
